module.exports = __webpack_public_path__ + "static/media/20ECE27.84f06a31.jpg";